document.addEventListener('mouseover', function (e) {
  var swatch = e.target.closest('.card-swatches__item');
  if (!swatch) return;

  var variantUrl = swatch.getAttribute('data-variant-image');
  if (!variantUrl) return;

  var card = swatch.closest('.card');
  if (!card) return;

  var img = card.querySelector('.card__media img');
  if (!img) return;

  if (!img.hasAttribute('data-original-src')) {
    img.setAttribute('data-original-src', img.getAttribute('src'));
    img.setAttribute('data-original-srcset', img.getAttribute('srcset') || '');
  }

  img.setAttribute('src', variantUrl);
  img.removeAttribute('srcset');
  card.classList.add('swatch-hover-active');
});

document.addEventListener('mouseout', function (e) {
  var swatch = e.target.closest('.card-swatches__item');
  var swatchContainer = e.target.closest('.card-swatches');
  if (!swatch && !swatchContainer) return;

  if (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.card-swatches')) return;

  var card = (swatch || swatchContainer).closest('.card');
  if (!card) return;

  var img = card.querySelector('.card__media img');
  if (!img) return;

  var originalSrc = img.getAttribute('data-original-src');
  var originalSrcset = img.getAttribute('data-original-srcset');

  if (originalSrc) {
    img.setAttribute('src', originalSrc);
    if (originalSrcset) {
      img.setAttribute('srcset', originalSrcset);
    }
  }

  card.classList.remove('swatch-hover-active');
});